{
  "title": "Ծանուցումներ",
  "empty": {
    "title": "Առաջիկա իրադարձություններ չկան",
    "hint": "Ծննդյան օրերը, առաջիկա արձակուրդներն ու տոներն այստեղ կհայտնվեն։"
  },
  "when": {
    "today": "Այսօր",
    "tomorrow": "Վաղը",
    "inDays": "{{count}} օրից"
  },
  "events": {
    "birthday": "{{name}}-ը դառնում է {{turns}} տարեկան",
    "timeOffStart": "{{name}} — սկսվում է {{type}} (մինչև {{end}})",
    "timeOffEnd": "{{name}}-ը վերադառնում է աշխատանքի",
    "holiday": "Տոն՝ {{name}}"
  },
  "dropdownHint": "Առաջիկա 14 օրը"
}
